import { Outlet, useLocation, Link } from "react-router";
import { HelpCircle } from "lucide-react";
import Sidebar from "./Sidebar";

/** パスからヘルプセクションIDへのマッピング */
const helpSectionMap: Record<string, string> = {
  "/": "dashboard",
  "/messages": "messages",
  "/conversations": "conversations",
  "/templates": "templates",
  "/bulk-send": "bulk-send",
  "/staff": "settings",
  "/opt-outs": "opt-outs",
  "/devices": "devices",
  "/settings": "settings",
};

export default function AppShell() {
  const { pathname } = useLocation();
  const helpSection = helpSectionMap[pathname] || "dashboard";

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex-1 p-6 overflow-auto relative">
        <Link
          to={`/help#${helpSection}`}
          className="fixed bottom-4 right-4 z-30 p-2 rounded-full bg-white border shadow-sm text-slate-400 hover:text-blue-500 hover:border-blue-300 transition-colors"
          title="このページのヘルプ"
        >
          <HelpCircle size={18} />
        </Link>
        <Outlet />
      </main>
    </div>
  );
}
